import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

export function BridgeNetworkAllowlistInformation() {
    return (
        <span>
            {Messages.bridgeSiteSettingsAllowlistRegistryInfo()}
            <TextLinkWidget
                className={learnMoreStyle}
                href={HelpService.getServerHelpUrlByCategory('server-bridge-registry')}
                target='_blank'
                testId={'learn-more'}
            >
                {Messages.learnMore()}
            </TextLinkWidget>
        </span>
    );
}
